import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import acls from "./acls.module";
import devices from "./devices.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import modal from "./modal.module";
import breadcrumbs from "./breadcrumbs.module";
import actions from "./actions.module";
import profile from "./profile.module";
import signIns from "./signins.module";
import terminal from "./terminal.module";
import tokens from "./tokens.module";
import adminUsers from "./admin/users.module";
import adminDevices from "./admin/devices.module";
import adminFirmwares from "./admin/firmwares.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    acls,
    devices,
    htmlClass,
    config,
    modal,
    breadcrumbs,
    actions,
    profile,
    signIns,
    terminal,
    tokens,
    adminUsers,
    adminDevices,
    adminFirmwares
  }
});
